import { Component, OnInit } from '@angular/core';
import { AuthService, User, TranslatePipe } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { FormatUsernamePipe } from '../../../shared/pipes/format-username.pipe';

@Component({
    selector: 'app-homepage-greeting',
    templateUrl: './homepage-greeting.component.html',
    imports: [AsyncPipe, TranslatePipe, FormatUsernamePipe]
})
export class HomepageGreetingComponent implements OnInit {
  user$: Observable<User | undefined>;

  constructor(
    private auth: AuthService,
    private userAccount: UserAccountFacade
  ) {}

  ngOnInit(): void {
    this.user$ = this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          return this.userAccount.get();
        } else {
          return of(undefined);
        }
      })
    );
  }
}
